import { render, staticRenderFns } from "./CreateMessage.vue?vue&type=template&id=69a0be76&scoped=true"
import script from "./CreateMessage.vue?vue&type=script&lang=js"
export * from "./CreateMessage.vue?vue&type=script&lang=js"
import style0 from "./CreateMessage.vue?vue&type=style&index=0&id=69a0be76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a0be76",
  null
  
)

export default component.exports